import React from 'react';
import { motion } from 'framer-motion';
const challenges = ['STRUCTURED LESSONS', 'CLEAR VISUAL EXPLANATIONS', 'ORGANIZED WORKSHOP ACTIVITIES', 'LOGICAL PROGRESSIONS', 'PROFESSIONAL TEACHING MATERIAL'];
const alreadyHave = ['You already have the framework.', 'You already have the progression.', 'You already have the diagrams.', 'You already have the teaching tools.', 'You already have the diagnostic workflows.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-primary/10" data-id="element-43" data-mp="1de70fpedcg34">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-44" data-mp="1dh2zxi5v7cto">
        <h2 className="text-3xl md:text-4xl font-display font-bold uppercase text-primary mb-6" data-id="element-45" data-mp="2152z96h8sbjv">
          What Automotive Technology Instructors Really Need Is Not More Information
        </h2>
        <p className="text-xl text-primary/75 mb-4" data-id="element-46" data-mp="24ww8cmdmhq4s">
          There is already more Automotive Technology information available than any instructor
          could ever use.
        </p>
        <p className="text-xl text-primary/75 mb-6" data-id="element-47" data-mp="1v6l1aqyn70to">
          <span className="text-secondary font-semibold" data-id="element-48" data-mp="1v3ywgz34yzf5">The real challenge</span> is turning that
          information into:
        </p>
        <ul className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-49" data-mp="1l7cdkfudeifr">
          {challenges.map(item => <li key={item} className="text-sm font-display font-bold tracking-wider text-primary bg-surface border border-accent rounded-md px-3 py-1.5" data-id="element-50" data-mp="1q7rpr42x1jw5">
              {item}
            </li>)}
        </ul>
        <div className="bg-white border border-primary/15 rounded-xl p-8 shadow-sm shadow-primary/5 text-lg text-body space-y-2" data-id="element-51" data-mp="1h7v4lcfqj35u">
          <p data-id="element-52" data-mp="3bkbagc4mcfa6">
            With Automotive Technology Instructor Ready, you do not have to begin every class from
            an empty page.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-primary font-semibold" data-id="element-53" data-mp="3539rexw62rby">
              {line}
            </p>)}
          <p className="text-primary font-semibold" data-id="element-54" data-mp="305rhb46ey62d">
            And with <span className="text-secondary" data-id="element-55" data-mp="2v5lmjf4uk3g2">150 ready-to-teach lessons</span>, you already
            have the lesson.
          </p>
        </div>
      </motion.div>
    </section>;
}